<template>
  <!-- 弹出框 -->
  <a-modal
    v-model="modal.visible"
    :title="modal.title"
    okText="回复"
    @cancel="cancel"
    @ok="modal.childVisible = true"
    :maskClosable="false"
    :width="720"
  >
    <a-descriptions
      :title="info.type == 'advice' ? '建议' : '投诉'"
      :column="2"
    >
      <a-descriptions-item label="记录编号">{{
        info.feedbackNo
      }}</a-descriptions-item>
      <a-descriptions-item label="创建时间">{{
        info.createDatetime
      }}</a-descriptions-item>
      <a-descriptions-item label="创建人">
        {{ info.createUser }}
        <a-tag
          class="render-tag"
          :color="info.type == 'advice' ? '#108ee9' : 'red'"
          >{{ info.type == "advice" ? "建议" : "投诉" }}</a-tag
        >
      </a-descriptions-item>
      <a-descriptions-item label="状态">
        <a-tag
          class="render-tag"
          :color="info.sta == 'I' ? '#108ee9' : 'grey'"
          >{{ info.sta == "I" ? "已处理" : "未处理" }}</a-tag
        >
      </a-descriptions-item>
      <a-descriptions-item label="内容" :span="2">{{
        info.content
      }}</a-descriptions-item>
    </a-descriptions>
    <a-divider />

    <h3>回复列表</h3>
    <a-list item-layout="horizontal" :data-source="recordList">
      <a-list-item slot="renderItem" slot-scope="item, index" :key="index">
        <a-list-item-meta :description="item.backContent">
          <span slot="title" style="font-weight: bold;">{{
            item.backUserName ? item.backUserName : "暂无"
          }}</span>
        </a-list-item-meta>
        <div>{{ item.backTime }}</div>
      </a-list-item>
    </a-list>

    <a-modal
      :visible="modal.childVisible"
      title="回复"
      :width="500"
      @cancel="replyCancel"
    >
      <a-form-model
        ref="ruleForm"
        :model="formData"
        :rules="rules"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 20 }"
      >
        <a-form-model-item label="内容" prop="backContent"
          ><a-input v-model="formData.backContent" type="textarea"
        /></a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button key="back" @click="replyCancel">取消</a-button>
        <a-button
          key="submit"
          type="primary"
          v-hasAnyPermission="`advicecomplaint:reply`"
          :loading="confirmLoading"
          @click="replySave"
          >回复</a-button
        >
      </template>
    </a-modal>
  </a-modal>
</template>

<script>
export default {
  name: "FeedbackInfo",
  data() {
    return {
      confirmLoading: false,
      //弹出框参数
      modal: {
        visible: false,
        title: "查看",
        childVisible: false
      },
      info: {},
      recordList: [],
      formData: {
        feedbackNo: "",
        backContent: ""
      },
      rules: {
        backContent: [
          {
            required: true,
            message: "请输入回复内容",
            trigger: "change"
          }
        ]
      }
    };
  },
  created() {},
  methods: {
    showModal(data) {
      this.modal.visible = true;
      this.info = data;
      this.formData.feedbackNo = this.info.feedbackNo;
      this.queryRecord();
    },
    cancel() {
      this.recordList = [];
      this.formData = {};
      this.modal.visible = false;
    },
    queryRecord() {
      this.$http.systemBksApi
        .listSystemFeedbackReplyByFeedbackNo({
          feedbackNo: this.formData.feedbackNo
        })
        .then(res => {
          if (res.result == 0) {
            this.recordList = res.resultObject;
          }
        });
    },
    replyCancel() {
      this.confirmLoading = false;
      this.modal.childVisible = false;
      this.$refs.ruleForm.resetFields();
    },
    replySave() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.confirmLoading = true;
          let param = Object.assign({}, this.formData);
          this.$http.systemBksApi.saveSystemFeedbackReply(param).then(res => {
            this.confirmLoading = false;
            if (res.result == 0) {
              this.$message.success(res.msg);
              this.replyCancel();
              this.cancel();
              this.$emit("success");
            }
          });
        }
      });
    }
  }
};
</script>

<style></style>
